"use strict";
// Async boundary required by Module Federation so shared singletons are negotiated before any
// React code executes.
import('./bootstrap');
